module.exports = __webpack_public_path__ + "img/logo-hotel-transparent-scaled.72302611.png";